<div class="popup marginBottomStyle" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
    style="position: relative; overflow: hidden; height: 100%">
    <div cdkDragHandle>
        <label i18n="@@spmsUserReg" class="textColour">Web Content and Data Extraction</label>
        <span class="example-spacer"></span>
    </div>
    <div style="height: 83%; overflow: hidden">
        <div style="height: 98%; overflow: auto">
            <form novalidate [formGroup]="formValid" style="margin-bottom: 3em">
                <div class="container">
                    <div style="max-width: 0; max-height: 0; overflow: hidden">
                        <input autofocus="true" />
                    </div>
                    <div class="row topRowMargins" style="margin-bottom: 0;">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg-11" style="    padding-right: 0;">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@targetloginusername">
                                    Domain
                                </mat-label>
                                <mat-select formControlName="dnsName" [(ngModel)]="scrapingWebPageDetails.dnsName" required (ngModelChange)="onVersionDropDownChange($event)">
                                    <mat-option>None</mat-option>
                                        <mat-option *ngFor="let tempObject of vaultids" [value]="tempObject.dnsname" [disabled]="tempObject.status == 'No'">
                                            {{tempObject.envname}}
                                        </mat-option>

                                </mat-select>
                                <mat-error *ngFor="let validation of validation_messages.dnsName">
                                    <span
                                        *ngIf="formValid.get('dnsName').hasError(validation.type) && (formValid.get('dnsName').dirty || formValid.get('dnsName').touched)">
                                        {{ validation.message }}
                                    </span>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins" style="margin-top: 0;">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg-11">
                            <div cdkDragHandle>
                                <label i18n="@@spmsUserReg" class="textColour" style="margin-bottom: 0;">
                                    Choose Required Type (Case/AER/Document)
                                </label>
                                <span class="example-spacer"></span>
                            </div>
                        </div>
                        <div class="col-lg-11">
                            <div cdkDragHandle>
                                <span class="textColour" [style.color]="backgroundColorButton" style="font-size: 12px;border: none;">Note: Home Screen Extraction will be added by default</span>
                                <span class="example-spacer"></span>
                            </div>
                        </div>
                       
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row topRowMargins" style="margin-top: 0;">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg-11">
                            <label i18n="@@spmsUserReg" class="textColour" style="border-bottom:none;margin-bottom: 0;">
                                Case
                            </label>
                            <div *ngFor="let caseObjects of Params.Params.Case;index as i" class="row topRowMargins" style="margin-top: 0;margin-bottom: 0;">
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            Case Number
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'caseNumber'+i" 
                                            [(ngModel)]="caseObjects.ObjectId" (change)="onCaseNumberChange(caseObjects,i)"  />
                                        <!-- <mat-error *ngFor="let validation of validation_messages.emailFormControl">
                                        <span
                                            *ngIf="formValid.get('caseNumber').hasError(validation.type) && (formValid.get('caseNumber').dirty || formValid.get('caseNumber').touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error> -->
                                    </mat-form-field>

                                </div>
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            Case Name
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'caseName'+i"
                                            [(ngModel)]="caseObjects.ObjectName" [required]="caseObjects.caseAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.caseName">
                                        <span
                                            *ngIf="formValid.get('caseName'+caseObjects.formControlIndex).hasError(validation.type) && (formValid.get('caseName'+caseObjects.formControlIndex).dirty || formValid.get('caseName'+caseObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-4" style="padding-right: 0;">
                                    <mat-form-field appearance="outline" style="width: 75%;">
                                        <mat-label i18n="@@targetloginusername">
                                            Description
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'caseDescription'+i"
                                            [(ngModel)]="caseObjects.Description" [required]="caseObjects.caseAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.Description">
                                        <span
                                            *ngIf="formValid.get('caseDescription'+caseObjects.formControlIndex).hasError(validation.type) && (formValid.get('caseDescription'+caseObjects.formControlIndex).dirty || formValid.get('caseDescription'+caseObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                    <button *ngIf="i > 0" title="Delete"(click)="removeCase(caseObjects,i)"  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920;margin-right: 0;">
                                        <i class="far fa-trash-alt"></i>
                                      </button>
                                    <!-- <mat-icon matPrefix>email</mat-icon> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row mb-1 topRowMargins" style= "left:0;bottom:0;width:100%">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg text-center" >
                
                            <div style="text-align: end">
                
                                <!-- <form novalidate [formGroup]="formValidCheckbox"> -->
                                    
                                    <button i18n="@@TargetClear" type="button" (click)="addCases()"
                                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                    style="padding-left:1.2rem;padding-right: 1.2rem;width:28%" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Add More Cases</button>
                            </div>
                 
                        </div>
                        <!-- <div class="col-lg-1"></div> -->
                        
                    </div>
                    <div class="row topRowMargins"  style="margin-top: 0;">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg-11">
                            <label i18n="@@spmsUserReg" class="textColour" style="border-bottom:none;margin-bottom: 0;">
                                AER
                            </label>
                            <div class="row topRowMargins" *ngFor="let aerObjects of Params.Params.AER;index as i" style="margin-top: 0;margin-bottom: 0;">
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            AER Number
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'aerNumber'+i"
                                            [(ngModel)]="aerObjects.ObjectId" (change)="onAERNumberChange(aerObjects,i)" />
                                        <!-- <mat-error *ngFor="let validation of validation_messages.emailFormControl">
                                        <span
                                            *ngIf="formValid.get('aerNumber').hasError(validation.type) && (formValid.get('aerNumber').dirty || formValid.get('aerNumber').touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error> -->
                                    </mat-form-field>

                                </div>
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            AER Name
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'aerName'+i"
                                            [(ngModel)]="aerObjects.ObjectName" [required]="aerObjects.aerAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.AERName">
                                        <span
                                            *ngIf="formValid.get('aerName'+aerObjects.formControlIndex).hasError(validation.type) && (formValid.get('aerName'+aerObjects.formControlIndex).dirty || formValid.get('aerName'+aerObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline" style="width: 75%;">
                                        <mat-label i18n="@@targetloginusername">
                                            Description
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'aerDescription'+i"
                                            [(ngModel)]="aerObjects.Description" [required]="aerObjects.aerAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.Description">
                                        <span
                                            *ngIf="formValid.get('aerDescription'+aerObjects.formControlIndex).hasError(validation.type) && (formValid.get('aerDescription'+aerObjects.formControlIndex).dirty || formValid.get('aerDescription'+aerObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                    <button *ngIf="i > 0" title="Delete"(click)="removeAer(aerObjects,i)"  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920;margin-right: 0;">
                                        <i class="far fa-trash-alt"></i>
                                      </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row mb-1 topRowMargins" style= "left:0;bottom:0;width:100%">

                        <div class="col-lg text-center" >
                
                            <div style="text-align: end">
                
                                <!-- <form novalidate [formGroup]="formValidCheckbox"> -->
                                    
                                    <button i18n="@@TargetClear" type="button" (click)="addAER()"
                                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                    style="padding-left:1.2rem;padding-right: 1.2rem;width:28%" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Add More AER</button>
                            </div>
                 
                        </div>
                        
                    </div>
                    <div class="row topRowMargins" style="margin-top: 0;">
                        <!-- <div class="col-lg-1"></div> -->
                        <div class="col-lg-11">
                            <label i18n="@@spmsUserReg" class="textColour" style="border-bottom:none;margin-bottom: 0;">
                                Document
                            </label>
                            <div class="row topRowMargins" *ngFor="let documentObjects of Params.Params.Document;index as i" style="margin-top: 0;margin-bottom: 0;">
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            Document Id
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'documentId'+i"
                                            [(ngModel)]="documentObjects.ObjectId" (change)="onDocumentChange(documentObjects,i)" />
                                        <!-- <mat-error *ngFor="let validation of validation_messages.emailFormControl">
                                        <span
                                            *ngIf="formValid.get('documentId').hasError(validation.type) && (formValid.get('documentId').dirty || formValid.get('documentId').touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error> -->
                                    </mat-form-field>

                                </div>
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline">
                                        <mat-label i18n="@@targetloginusername">
                                            Document Name
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'documentName'+i"
                                            [(ngModel)]="documentObjects.ObjectName" [required]="documentObjects.documentAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.documentName">
                                        <span
                                            *ngIf="formValid.get('documentName'+documentObjects.formControlIndex).hasError(validation.type) && (formValid.get('documentName'+documentObjects.formControlIndex).dirty || formValid.get('documentName'+documentObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-4">
                                    <mat-form-field appearance="outline" style="width: 75%;">
                                        <mat-label i18n="@@targetloginusername">
                                            Description
                                        </mat-label>
                                        <input matInput type="text" [formControlName]="'documentDescription'+i"
                                            [(ngModel)]="documentObjects.Description" [required]="documentObjects.documentAdded" />
                                        <mat-error *ngFor="let validation of validation_messages.Description">
                                        <span
                                            *ngIf="formValid.get('documentDescription'+documentObjects.formControlIndex).hasError(validation.type) && (formValid.get('documentDescription'+documentObjects.formControlIndex).dirty || formValid.get('documentDescription'+documentObjects.formControlIndex).touched)">
                                            {{ validation.message }}
                                        </span>
                                    </mat-error>
                                    </mat-form-field>
                                    <button *ngIf="i > 0" title="Delete"(click)="removeDocument(documentObjects,i)"  class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: .3rem .8rem;margin-top:0rem;background:#d71920;margin-right: 0;">
                                        <i class="far fa-trash-alt"></i>
                                      </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                    <div class="row mb-1 topRowMargins" style= "left:0;bottom:0;width:100%">

                        <div class="col-lg text-center" >
                
                            <div style="text-align: end">
                
                                <!-- <form novalidate [formGroup]="formValidCheckbox"> -->
                                    
                                    <button i18n="@@TargetClear" type="button" (click)="addDocument()"
                                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                                    style="padding-left:1.2rem;padding-right: 1.2rem;width:28%" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Add More Documents</button>      

                            </div>
                 
                        </div>
                        
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">

        <div class="col-lg text-center" >

            <div style="text-align: end">

                <!-- <form novalidate [formGroup]="formValidCheckbox"> -->
                    
                    <button i18n="@@TargetClear" type="button" (click)="sendDataAndClose()"
                    class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Run</button>

                    <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>        

                <!-- </form> -->

            </div>
 
        </div>
        
    </div>
    <!-- <button i18n="@@TargetCancel" type="button" (click)="closeFunction()"
        class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="padding-left: 1.2rem; padding-right: 1.2rem" [style.border-color]="backgroundColorButton"
        [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">
        Cancel
    </button> -->
</div>